'use client';

import { useState } from 'react';
import { Drawer } from 'glic-ui-components/esm';
import { Button } from '@/components/ui/button';
import { Entry } from 'contentful';
import { renderOptions } from '@/lib/contentfulOptions';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Document } from '@contentful/rich-text-types';
import { cn } from '@/lib/utils';

const DISCLOSURE_DRAWER_WIDTH_CLASS = '!w-full !max-w-[1290px]';

export const Disclosures = ({
  cta,
  data,
  className,
}: {
  cta: string;
  className?: string;
  data: Entry;
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <>
      <Button
        variant="link"
        className={cn('text-lg font-bold', className)}
        data-ta="open-important-product-disclosures"
        data-state={isDrawerOpen ? 'open' : 'closed'}
        onClick={handleOpenDrawer}
      >
        {cta}
      </Button>
      <Drawer
        show={isDrawerOpen}
        onHide={handleCloseDrawer}
        position="right"
        heading={cta}
        elementProps={{
          modal: {
            elementProps: {
              dialog: {
                className: DISCLOSURE_DRAWER_WIDTH_CLASS,
              },
              wrapper: {
                className: `${DISCLOSURE_DRAWER_WIDTH_CLASS} !min-w-0`,
              },
            },
          },
        }}
      >
        <div className="h-full p-8 overflow-y-auto">
          {documentToReactComponents(
            data.fields.description as Document,
            renderOptions
          )}
        </div>
      </Drawer>
    </>
  );
};
